import { motion } from 'framer-motion';

export default function PharmacyHero() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ minHeight: '300px' }}
      aria-labelledby="pharmacy-hero-heading"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20pharmacy%20interior%20organized%20prescription%20counter%20medicine%20shelves%20professional%20healthcare%20setting%20clean%20white%20and%20teal%20tones%20warm%20lighting%20welcoming%20atmosphere%20wide%20angle%20view%20pharmaceutical%20care%20center&width=1920&height=400&seq=phero-bg-v2&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-top"
          width={1920}
          height={400}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/75 to-gray-900/60" aria-hidden="true" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center pt-28 md:pt-32 pb-10 md:pb-12" style={{ minHeight: '280px' }}>
        {/* Breadcrumb */}
        <nav aria-label="Breadcrumb" className="mb-4 md:mb-5">
          <ol className="flex items-center flex-wrap gap-y-1 space-x-2 text-sm">
            <li><a href="/" className="text-white/70 hover:text-white transition-colors">Home</a></li>
            <li aria-hidden="true"><i className="ri-arrow-right-s-line text-white/50"></i></li>
            <li><a href="/pharmacy-services" className="text-white/70 hover:text-white transition-colors">Services</a></li>
            <li aria-hidden="true"><i className="ri-arrow-right-s-line text-white/50"></i></li>
            <li><span className="text-teal-400 font-medium">Pharmacy Services</span></li>
          </ol>
        </nav>

        <motion.h1
          id="pharmacy-hero-heading"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-2xl"
        >
          Comprehensive Pharmacy Services
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }}
          className="mt-3 md:mt-4 text-sm md:text-lg text-white/80 max-w-xl"
        >
          Professional pharmaceutical care and health solutions in Thornhill, Ontario
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
          className="mt-6 md:mt-8 flex flex-wrap gap-3 md:gap-4"
        >
          <a
            href="tel:9057099985"
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-5 md:px-7 py-2.5 md:py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-phone-line"></i>
            (905) 709-9985
          </a>
          <a
            href="/location"
            className="inline-flex items-center gap-2 border border-white/40 hover:border-white text-white font-semibold px-5 md:px-7 py-2.5 md:py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-map-pin-line"></i>
            Visit Our Location
          </a>
        </motion.div>
      </div>
    </section>
  );
}
